export const CONSTANTS = {
  BASE_URL: import.meta.env.BASE_URL,
  APP_ENV: import.meta.env.VITE_APP_ENV,
  APP_SLUG: import.meta.env.VITE_APP_SLUG,
  IS_PRODUCTION: import.meta.env.VITE_APP_ENV === "production",
  IS_STAGING: import.meta.env.VITE_APP_ENV === "staging",
  IS_LOCAL: import.meta.env.VITE_APP_ENV === "local",
  // Flip to true once the backend subscription migration is live on prod.
  SELF_SERVE_SUBSCRIPTION: true,
  APP_TITLE: import.meta.env.VITE_APP_TITLE,
  BACKEND_URL: import.meta.env.VITE_BACKEND_API,
  CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  DEFAULT_FOOTER_HEIGHT: 220,
  COLLAPSED_FOOTER_HEIGHT: 56,
  PUSHER_KEY: import.meta.env.VITE_PUSHER_KEY,
  LOGO_FULL: import.meta.env.VITE_LOGO_FULL,
  LOGO_FULL_LIGHT: import.meta.env.VITE_LOGO_FULL_LIGHT,
  LOGO_ICON: import.meta.env.VITE_LOGO_ICON,
  FAVICON: import.meta.env.VITE_FAVICON,
  BRAND_NAME: import.meta.env.VITE_BRAND_NAME,
  SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL,
  SALES_PHONE: "+9779817198789",
  COMPANY_ADDRESS: "",
  COMPANY_TAX_ID: "",
  TERMS_URL: import.meta.env.VITE_TERMS_URL,
  PRIVACY_URL: import.meta.env.VITE_PRIVACY_URL,
  DD_APPLICATION_ID: import.meta.env.VITE_DD_RUM_APPLICATION_ID,
  DD_CLIENT_TOKEN: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
  FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID,
  INSTAGRAM_CLIENT_ID: import.meta.env.VITE_INSTAGRAM_CLIENT_ID,
  FACEBOOK_ADS_CONFIG_ID: import.meta.env.VITE_FACEBOOK_LOGIN_ADS_CONFIGURATION_ID,
  MESSENGER_SCOPES:
    "pages_manage_metadata,pages_messaging,pages_read_engagement,pages_show_list,business_management,pages_read_user_content,pages_manage_engagement",
};

/**
 * Central AI-assistant ("Sophus") branding — the single source of truth for the
 * assistant's name and composer trigger. Change the name / trigger here to
 * rebrand everywhere Sophus surfaces: the composer `@sophus` command + highlight,
 * the drafting states, the Agent activity timeline, the AI agent studio, the
 * inbox conversation filter, and the AI summary label all read from this constant.
 */
export const AI_ASSISTANT = {
  /** Display name used in UI copy. */
  name: "Sophus",
  /** Keyword users type after a prefix to invoke a reply draft. */
  keyword: "sophus",
  /** Prefixes that may precede the keyword in the composer (e.g. "@sophus" / "/sophus"). */
  triggerPrefixes: ["@", "/"] as const,
} as const;

export const EXTERNAL_LINKS = {
  adsManager: {
    youtube: "https://youtu.be/7BlTbX8VFIQ",
    blogs: [] as string[],
  },
  team: {
    youtube:
      "https://www.youtube.com/watch?v=fLWPridDhyI&list=PLKDN-PEJ6uZs&index=5",
    blogs: [] as string[],
  },
  instagram: {
    connect:
      "https://www.youtube.com/watch?v=Bf9Sb2OHn9E&list=PLKDN-PEJ6uZs&index=1",
    reconnect:
      "https://www.youtube.com/watch?v=AMXny-QJXSM&list=PLKDN-PEJ6uZs&index=3",
    blogs: [] as string[],
  },
  snippets: {
    youtube:
      "https://www.youtube.com/watch?v=xbsOuiBI7sM&list=PLKDN-PEJ6uZs&index=2",
    blogs: [] as string[],
  },
};

export const PUSHER_EVENTS = {
  NEW_CONTACT: "new-contact",
  NEW_ACTIVITY: "new-activity",
  NEW_MESSAGE: "new-message",
  MESSAGE_STATUS_UPDATE: "message-status-update",
  CONTACT_INTERACTION_UPDATE: "contact-interaction-update",
  TEMPLATE_UPDATE: "template-update",
  CONTACT_CHANNEL_UPDATE: "contact-channel-update",
  APPOINTMENT_CREATED: "appointment-created",
  APPOINTMENT_UPDATED: "appointment-updated",
  APPOINTMENT_DELETED: "appointment-deleted",
  MESSAGE_EDIT: "message-edit",
  MESSAGE_REACTION: "message-reaction",
  MESSAGE_MEDIA_READY: "message-media-ready",
  MESSAGE_DELETE: "message-delete",
  MESSAGES_SYNCED: "messages-synced",
  ACTIVITY_UPDATE: "activity-update",
  CONTACT_UPDATE: "contact-update",
  SEGMENT_EXPORT_READY: "segment-export-ready",
  MENTION_ALERT: "mention-alert",
  FOLLOW_UP_DUE_ALERT: "follow-up-due-alert",
  AGENT_STEP: "agent-step",
};
